import { cn } from '@/clientOnlyUtils/cn';
import React, { type ComponentProps } from 'react';

import { UpdateAvailableBanner } from '~/components/UpdateAvailableBanner';

type StackProps = {
  gap?: string | number;
  direction?: 'row' | 'column';
  justifyContent?: 'start' | 'end';
  uniformChildren?: boolean;
  gridColumns?: string;
};

export type StackDivProps = React.HTMLProps<HTMLElement> & StackProps;

type PropsFullHeight = ComponentProps<'div'> & {
  style?: React.CSSProperties;
};

export function FullHeight({ children, className, style, ref }: PropsFullHeight) {
  return (
    <div
      className={cn('flex h-lvh w-full flex-col items-stretch justify-stretch overflow-hidden', className)}
      style={style}
      ref={ref}>
      <UpdateAvailableBanner />
      {children}
    </div>
  );
}

export function FlexGrowHeight({ className, ...props }: PropsFullHeight) {
  return <div className={cn('relative flex w-full grow items-stretch justify-stretch', className)} {...props} />;
}
type WithLeftNav = ComponentProps<'div'> & {
  hasDetail: boolean;
  detailSize?: 'small';
};
export const WithLeftNav = ({ children, hasDetail, detailSize }: WithLeftNav) => {
  return (
    <div
      className={cn(
        'relative ml-[var(--nav-width)] flex grow flex-col items-stretch justify-stretch overflow-hidden bg-slate-50 font-sans text-slate-600 transition-all dark:bg-neutral-800 dark:text-white',

        { 'mr-[var(--detail-width)]': hasDetail, 'mr-[var(--detail-width-small)]': detailSize },
      )}>
      {children}
    </div>
  );
};

interface WithOutLeftNav extends ComponentProps<'div'> {
  hasDetail: boolean;
  detailSize?: 'small';
}
export const WithOutLeftNav = ({ children, hasDetail, detailSize }: WithLeftNav) => {
  return (
    <div
      className={cn(
        'relative ml-0 flex grow flex-col items-stretch justify-stretch overflow-hidden bg-slate-50 font-sans text-slate-600 transition-all dark:bg-neutral-800 dark:text-white',
        { 'mr-[var(--detail-width)]': hasDetail, 'mr-[var(--detail-width-small)]': detailSize },
      )}>
      {children}
    </div>
  );
};
